export type FilterLogicalOperator = 'AND' | 'OR';

export type FilterKeyword = string | Date | string[];

export interface FilterOperatorOption {
    key: string;
    value: string;
}

export interface FilterAttributeOption {
    name: string;
    label?: string;
    translatedLabel?: string;
    baseClass?: string;
    typeName?: string;
    template?: string;
}

export interface FilterRule {
    attribute?: FilterAttributeOption | string | null;
    operator: string;
    keyword: FilterKeyword;
    notOperator: boolean;
    connector?: FilterLogicalOperator;
}

export interface FilterGroup {
    rules: FilterRule[];
    operator?: FilterLogicalOperator;
    notOperator: boolean;
    ruleConnector: FilterLogicalOperator;
}

export interface ItemsSearchFilterQuery {
    keyword: string;
}

export interface ItemsSearchFilter {
    name: string;
    isPublic?: boolean;
    itemsQuery?: ItemsSearchFilterQuery;
    id?: string;
    identifier?: string;
    label?: string;
    type?: string;
    readOnly?: boolean;
}

export const FILTER_OPERATORS: FilterOperatorOption[] = [
    { key: ':', value: '=' },
    { key: '==', value: '==' },
    { key: '<', value: '<' },
    { key: '<=', value: '<=' },
    { key: '>', value: '>' },
    { key: '>=', value: '>=' },
];

export const DEFAULT_FILTER_OPERATOR = ':';
